<template>
  <div class="template_section_select">
    <div class="items">
      <v-text-field
        v-model="datatypesFilter.name"
        outlined
        :label="'Rechercher une question'"
        prepend-inner-icon="$mdiMagnify"
        dense
        hide-details
        @input="filterDatatypes"
      />
      <div class="separator" />
    </div>
    <div class="questions__list" @scroll="handleDataTypeScroll">
      <div
        v-for="(datatype, index) in datatypes.items"
        :key="`${index}-ql`"
        class="questions__item"
        :draggable="true"
        @dragstart="handleDrag($event, datatype)"
      >
        <div class="left_item">
          <div class="question__name">{{ datatype.name }}</div>
          <div class="question__slug">{{ datatype.slug && "" }}</div>
        </div>
        <div class="right_item">{{ datatype.typeQuestion }}</div>
      </div>
      <template v-if="datatypesFilter.loading">
        <v-skeleton-loader
          v-for="x in 5"
          :key="x"
          class="item_skeleton"
          type="text"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { fetchDatatypes } from "@/core/Services/datatype.service";

export default {
  name: "DataTypeQuestionWidget",
  data() {
    return {
      datatypes: {
        items: [],
        count: 0,
        next: 0,
        previous: 0,
      },
      datatypesFilter: {
        loading: false,
        page: 1,
        pageSize: 10,
        name: undefined,
        searchTimeoutRef: undefined,
      },
    };
  },
  created() {
    this.fetchDatatypes();
  },
  methods: {
    handleDrag(event, item) {
      event.dataTransfer.setData(
        "application/json",
        JSON.stringify({ ...item, datatype: item.id, questionType: "DATATYPE" })
      );
    },
    async handleDataTypeScroll(event) {
      const el = event.target;
      const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
      if (isAtBottom) {
        await this.loadMoreDatatypes();
      }
    },
    async fetchDatatypes() {
      this.datatypesFilter.loading = true;
      try {
        this.datatypesFilter.page = 1;
        this.datatypes = await fetchDatatypes({
          organizationId: this.$route.params.organizationId,
          page: this.datatypesFilter.page,
          name: this.datatypesFilter.name,
          pageSize: this.datatypesFilter.pageSize,
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.datatypesFilter.loading = false;
    },
    filterDatatypes() {
      if (this.datatypesFilter.searchTimeoutRef)
        clearTimeout(this.datatypesFilter.searchTimeoutRef);
      this.datatypesFilter.searchTimeoutRef = setTimeout(async () => {
        this.fetchDatatypes();
      }, 500);
    },
    async loadMoreDatatypes() {
      if (this.datatypesFilter.loading || !this.datatypes.next) return;
      this.datatypesFilter.page = this.datatypes.next;
      this.datatypesFilter.loading = true;
      try {
        const tmp = await fetchDatatypes({
          organizationId: this.$route.params.organizationId,
          page: this.datatypesFilter.page,
          name: this.datatypesFilter.name,
          pageSize: this.datatypesFilter.pageSize,
        });
        this.datatypes = {
          ...tmp,
          items: [...this.datatypes.items, ...tmp.items],
        };
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.datatypesFilter.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.template_section_select {
  .items {
    padding: 0 8px;
  }
  .separator {
    margin: 16px 0;
    height: 1px;
    border-top: 1px solid black;
  }
  .questions__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 370px;
    overflow-y: auto;
    padding: 0 8px;
    .item_skeleton {
      height: 52px;
      width: 100%;
      ::v-deep {
        .v-skeleton-loader__bone {
          height: 48px;
        }
      }
    }
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 3px;
      border: 1px solid #eeeef7;
    }

    &::-webkit-scrollbar-thumb {
      background: #b6bdff;
      border-radius: 3px;
    }
    .questions__item {
      border: 1px solid black;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 6px;
      padding: 4px 8px;
      background: #f5f8ff;
      cursor: grabbing;
      .left_item {
        .question__name {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 4px;
        }
        .question__slug {
          font-size: 12px;
        }
      }
      .right_item {
        font-size: 18px;
        font-weight: 500;
        color: #2536cc;
      }
    }
  }
}
</style>
